import { render, staticRenderFns } from "./socialResponsibily.vue?vue&type=template&id=394b4f84&"
import script from "./socialResponsibily.vue?vue&type=script&lang=js&"
export * from "./socialResponsibily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports